import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';


const template = styled.div`
  ${({ displayState }) => css`
      font-size: 12px;
      color:  ${window?.settings?.primary_color ?? '#1DBD6B'};
      background: white;
      border-radius: 60px;
      padding: 3px 20px;
      transition: background .3s ease-out, color .3s ease-out, order .5s linear;
    
      ${({ displayState }) => displayState.switchState == 'right' && css`
        color: white;
        background: ${window?.settings?.primary_color ?? '#1DBD6B'};
      `};

    `}
`;


export default Atom({ type: 'label', dataType: 'string', template })
